import { render } from "./SectionBanner.vue?vue&type=template&id=3c921911"
import script from "./SectionBanner.vue?vue&type=script&lang=js"
export * from "./SectionBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__